module.exports = __webpack_public_path__ + "src/components/Avatar/defaultPic.png?04ed1861";


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/defaultPic.png
// module id = 3076
// module chunks = 8